<template>
  <div class="apply-info-page">
    <h1>尊敬的医生</h1>
    <p>您好！</p>
    <p>感谢您选择正雅儿牙矫治产品，接下来，我们将一起重新定义儿牙矫治。</p>
    <p>为了更好地协助您提升病例量、避免治疗尴尬期，我公司在儿牙矫治产品（咬合诱导版、早期矫治版）中增加了正畸定位器工具包：包含正畸定位器6个（价值2300元/6个）。与我公司签订以上产系的合作合同后，机构医生均可以个人名义向正雅借用壹个工具包，借用期限为一年（从借用申请之日开始起算）。若借用期限届满且合作合同续签，则根据合同期限相应延期。在借用期间，若物品损坏或丢失，正雅不再另行补发。</p>
    <p>点击确认即代表您已了解以上说明并申请借用正畸定位器6个。</p>
    <p>2022年3月2日</p>
    <p>正雅齿科科技（上海）有限公司</p>
    <div class="btns">
      <van-button type="info" round size='large' @click="jumpToApplyAddress" block>已充分了解并同意借用说明</van-button>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
    }
  },
  methods: {
    jumpToApplyAddress () {
      this.$router.push({ path: `/apply-address` })
    },
  }
}
</script>
<style lang="less" scoped>
.apply-info-page {
  padding: 30px 30px 50px 30px;
  p {
    margin-top: 20px;
    font-size: 30px;
    line-height: 45px;
    text-indent: 32px;
    color: @hGray;
  }
  .btns {
    width: 80%;
    margin: 40px auto;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/member/apply-locate.vue